import { useEffect, useMemo, useRef } from "react";
import { useJoin, useLocalCameraTrack, useLocalMicrophoneTrack, usePublish, useTrackEvent } from "agora-rtc-react";
import { useDeepDiveContext } from "../DeepDiveProvider";
import { CALL_PROGRESS, TOAST_TIME } from "../constants";
import { Joinee, Uids } from "../deepdiveSlice";
import { App } from "antd";

const ExternalCamera = () => {
  const { appId, channel, tokens, callProgress, micOn, externalCameraId, joinee, updateDeepDiveState, members, t, calling } =
    useDeepDiveContext();
  const { uids = {} } = joinee as Joinee;
  const { externalCameraAudioUid } = uids as Uids;
  const { externalCameraAudio: externalCameraAudioToken = "" } = tokens || {};
  const externalCameraOn = externalCameraId !== "";

  const member = useMemo(() => members && members[externalCameraAudioUid], [members, externalCameraAudioUid]);
  const memberRef = useRef(member);

  const { message } = App.useApp();

  useEffect(() => {
    memberRef.current = member;
  }, [member]);

  useJoin(
    { appid: appId, channel: channel, token: externalCameraAudioToken ? externalCameraAudioToken : null, uid: externalCameraAudioUid },
    callProgress === CALL_PROGRESS.IN_CALL_SCREEN && externalCameraOn && calling
  );

  // local user
  const { localMicrophoneTrack, error: micError } = useLocalMicrophoneTrack(micOn);
  const { localCameraTrack: localExternalCameraTrack, error: externalCameraError } = useLocalCameraTrack(externalCameraOn, {
    cameraId: externalCameraId,
  });
  usePublish([localMicrophoneTrack, localExternalCameraTrack], externalCameraOn);

  // error while mic sharing
  useEffect(() => {
    if (micOn && micError) {
      message.error(t("FAILED_MIC"), TOAST_TIME);
      updateDeepDiveState({ micOn: false });
    }
  }, [micOn, micError, updateDeepDiveState, message, t]);

  // error while external camera sharing
  useEffect(() => {
    if (externalCameraOn && externalCameraError) {
      message.error(t("FAILED_CAMERA"), TOAST_TIME);
      updateDeepDiveState({ externalCameraId: "" });
    }
  }, [externalCameraOn, externalCameraError, updateDeepDiveState, message, t]);

  useTrackEvent(localExternalCameraTrack, "track-ended", () => {
    if (externalCameraOn) updateDeepDiveState({ externalCameraId: "" });
  });

  return <></>;
};

export default ExternalCamera;
